import React from "react";

const HorizontalRoller = () => {
  return <hr className="my-10 w-[90%] mx-auto" />;
};

export default HorizontalRoller;
